import { useNavigate } from 'react-router-dom';
import {
    Box,
    Container,
    Typography,
    Button,
    Paper
} from '@mui/material';
import { Cancel } from '@mui/icons-material';

export const PaymentCancelPage = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'background.default'
            }}
        >
            <Container maxWidth="sm">
                <Paper
                    elevation={3}
                    sx={{
                        p: 6,
                        textAlign: 'center',
                        borderRadius: 3,
                        border: '2px solid',
                        borderColor: 'warning.main'
                    }}
                >
                    <Cancel
                        sx={{ fontSize: 80, color: 'warning.main', mb: 2 }}
                    />

                    <Typography variant="h4" fontWeight="bold" gutterBottom>
                        Pago cancelado
                    </Typography>

                    <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                        No se realizó ningún cargo. Puedes intentarlo de nuevo cuando quieras
                        o continuar con tu plan actual.
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                        <Button
                            variant="contained"
                            size="large"
                            onClick={() => navigate('/plans')}
                        >
                            Ver Planes
                        </Button>
                        <Button
                            variant="outlined"
                            size="large"
                            onClick={() => navigate('/')}
                        >
                            Ir al Inicio
                        </Button>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default PaymentCancelPage;
